<template>
  <div class="card-container relative flex w-full rounded-xl bg-primary-100 shadow-clickable-card">
    <div class="w-full py-3 pl-5 pr-2">
      <slot />
    </div>
    <div class="absolute right-3 top-1/2 flex -translate-y-1/2 transform items-center justify-center">
      <div
        :class="[
          'flex aspect-square w-6 items-center justify-center rounded-full bg-primary-600 align-middle',
          $attrs['onboarding-summary'] ? 'onboarding-next-arrow' : '',
        ]"
      >
        <i class="pi pi-angle-right text-white"></i>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-container {
  position: relative;
  overflow: hidden;
}
</style>
